import React, { useContext, useState } from 'react';
import { makeStyles , Typography } from '@material-ui/core';
import {Buzones} from './Buzones'
import {api, PortalContext} from '@portal/arq-portal-core';
import { Buzon } from '../types/types';

export const BuzonesList = (props:any) => { 
    const fixedBuzon: Buzon = {Titulo: "Alta/gestión de mi buzón de correo", Url:"/Aplicacion?aplicacion=AplicacionesSCO&urlTransaccion=FE/TPG.Aplic.TSCH.FE.BuzonCorreo/" }
    const {user,mostrarGestionBuzon} = useContext(PortalContext);
    const personal = [{Titulo: user?.dn ?? "", Url: user?.buzon ?? ""}];
    
    React.useEffect(()=>{
        var buzones:Buzon[] = personal;
        if(user?.buzones != null){
            api.get(user?.buzones).then((data: {Buzones: Buzon[]}) => {
                if (data !=null && data!= undefined) buzones = buzones.concat(data.Buzones);
                if (mostrarGestionBuzon) buzones = buzones.concat([fixedBuzon]);
                setData(buzones);
            });   
        }else{
            if (mostrarGestionBuzon) buzones = buzones.concat([fixedBuzon]);
            setData(buzones);
        }
    }, []);

    const [data, setData] = useState<Buzon[]>();

    const useStyles = makeStyles(theme => ({
        linea: {
        padding: theme.spacing(1)
        }, 
        container:{
            display: 'flex',
            flexDirection: 'column', 
            padding: '1.5rem',
            backgroundColor: 'white'
        },
        header:{
            fontFamily: "CO-Bold",
            fontSize: '18px',
            color: '#606060', 
            borderBottom: '1px solid #919191',
            paddingBottom: '15px',
            marginBottom: '10px',
        },
        cargaVacios: {
            padding: "20px", 
            width: "100%", 
            textAlign: "center", 
            fontSize: '14px',
            color: '#606060',
        }
    }));

    const classes = useStyles(props);

    return (
    <div className = {classes.container}>
       <h3 className={classes.header}>Buzones</h3>
       {!data&&<Typography variant="body1" className={classes.cargaVacios}>No se han recuperado buzones</Typography>}
        {data && <Buzones datos = {data}></Buzones>}
    </div>
    );
}